import { AxiosRequestConfig } from "axios";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
export default {
  LeaveStatus: {
    Approved: "A",
    Rejected: "R",
    CancelLeavePending: "CP",
    CancelledLeaveApproved: "CA",
    CancelledLeaveRejected: "CR"
  },

  LeaveType: {
    AL: "AL",
    CL: "CL"
  },

  DateTime: {
    yyyymmddhhmmssa: "YYYY-MM-DD HH:mm:ss a",
    yyyymm: "YYYY-MM",
    yyyymmdd: "YYYY-MM-DD",
    yyyymmddhhmmss: "YYYY-MM-DD HH:mm:ss",
    yyyymmddhhmm: "YYYY-MM-DD HH:mm",
    hhmmss: "HH:mm:ss",
    hhmm: "HH:mm"
  },

  MenuID: {
    Approval: "010000",
    OutdoorWork: "010100",
    Candidates: "010200",
    LeaveApplication: "030000",
    Report: "040000",
    StaffLeaveRecord: "040100",
    StaffAttendance: "040200",
    MonthlyLeaveBalance: "040300",
    OutdoorWorkAllowance: "040400",
    TaxReturn: "040500",
    MM: "050000",
    MM_LeaveType: "050100",
    MM_StaffGrading: "050200",
    MM_AnnualLeavePlan: "050300",
    MM_WorkType: "050400",
    MM_Holiday: "050500",
    MM_ShiftType: "050600",
    MM_Roster: "050700",
    MM_Loc: "050800",
    MM_RosterPlan: "050900",
    // MM_AutopayFile: "051000",
    Administration: "060000",
    UserList: "060100",
    UserGroups: "060200",
    UserGroupsRights: "060300",
    SyncUsertoMizar: "060400",
    Employees: "070000",
    Setup: "080000",
    S_EmployeeType: "080100",
    S_JobPosition: "080200",
    S_Academic: "080300",
    S_Skill: "080400",
    S_SourceofAppli: "080500",
    S_BenefitPlan: "080600",
    S_DocumentTemplate: "080700",
    S_District: "080800",
    S_Bank: "080900",
    S_Company: "081000",
    S_DocumentType: "081100",
    S_IDType: "081200",
    S_MaritalSatus: "081300",
    S_Relationship: "081400",
    S_Department: "081500",
    S_Team: "081600",
    S_EmployeeStatus: "081700",
    S_Assess: "081800",
    // S_PayProfile: "081900",
    S_PayGroup: "082000",
    S_PayType: "082100",
    S_PayMethod: "082200",
    S_IncType: "082300",
    Candidate: "090000",
    Job: "090100",
    NewCandidate: "090200",
    JobApplicationForm: "090300",
    Enquiry: "090400",
    Payroll: "100000",
    PayrollTrial: "101000",
    SpecialPayment: "102000",
    PayrollAdjustment: "103000",
    PayrollApproval: "104000",
    FinalPayment: "105000",
    PayProfile: "106000"
  },

  EmployeeStatus: {
    Hired: "H",
    Resigned: "R"
  },

  Permission: {
    Change: "AlwChg",
    Delete: "AlwDel",
    Export: "AlwExp",
    Import: "AlwImp",
    Print: "AlwPrt",
    Read: "AlwRead",
    Write: "AlwWrite"
  },

  PayrollStatus: {
    New: "00",
    Approving: "30",
    Approved: "60",
    Released: "65",
    Closed: "70",
    Rejected: "90"
  },

  SysParams: {
    ModCLK: "MODCLK",
    ModLv: "MODLV",
    ModRecu: "MODRECU",
    ModPay: "MODPAY",
    ShowLvBalance: "SHOWLVBAL",
    LateSubmit: "LATESUBMIT",
    DayStart: "DAYSTART",
    DayEnd: "DAYEND",
    QtyOfAmLeave: "QTYOFAMLEAVE",
    QtyOfPmLeave: "QTYOFPMLEAVE",
    HRDept: "HRDEPT",
    RosterBase: "ROSTERBASE",
    BexAccount: "BEXAC",
    WorkHoursSplit: "WORKHOURSSPLIT"
  },

  CompCode: {
    Eisai: "EISAI",
    ECINFO: "ECINFO",
    DMC: "DMC",
    ESSILOR: "ESSILOR",
    BEX: "BEX",
    SAILINGBOAT: "SAILINGBOAT",
    KT: "KT"
  },

  MsgStatus: {
    Approved: "A",
    Rejected: "R"
  },

  HolidayType: [
    {
      value: "LABOR",
      label: t.t(dictEnum.LBL_Labor)
    },
    {
      value: "BANK",
      label: t.t(dictEnum.TAB_Bank)
    }
  ]
};



// WEBPACK FOOTER //
// ./src/constants/Settings.js